<template>
    <div>
        <div class="section_padding_half section_grayBorder">
            <!-- TODO: class name below - is it correct? -->
            <div :class="['careersSearchControls', { careersSearchControls_noSearch: !searchBox }, `m-flexBoxJustify_${justify}`]">
                <div v-for="(filterObj, index) in filterCategories" :key="index">
                    <!-- v-if="filterObj.options" TODO: decide if this is how we handle filters -->
                    <label :for="name" class="isVisuallyHidden">{{filterObj.label}}</label>
                    <div class="select">
                        <select :title="filterObj.headline" :aria-label="filterObj.headline=='' ? filterObj.label : filterObj.headline" :name="filterObj.name" :id="filterObj.name" class="select" @change="onValueChosen(filterObj.name, $event.target.value)" :disabled="!itemsPresent && !filterObj.options">
                            <option value="" v-if="filterObj.headline">{{filterObj.headline}}</option>
                            <option value="" v-if="filterObj.label">{{filterObj.label}}</option>
                            <option v-for="(option, index) in filterObj.options" :key="index" :value="option.value" :selected="option.isSelected">{{option.text}}</option>
                        </select>
                        <div class="select-icon">
                            <i class="icon icon_dropdownArrow"></i>
                        </div>
                    </div>
                </div>
                <div v-if='searchBox' class="search">
                    <input type="text" placeholder="Keyword" :name="queryInputName" aria-label="keyword search" autocomplete="off" class="search-textInput" @input="updateSearchString($event.target.value)" :value="defaultQuery">
                    <div class="search-searchIcon">
                        <i class="icon icon_search"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'filterCategories',
            'updateSearchString',
            'onValueChosen',
            'searchBox',
            'itemsPresent',
            'justify',
            'queryInputName',
            'defaultQuery'
        ]
    };
</script>

